<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M14.43 8.87999C14.43 11.33 12.44 13.32 9.98999 13.32C7.53999 13.32 5.54999 11.33 5.54999 8.87999V5.54999C5.54999 3.09999 7.53999 1.10999 9.98999 1.10999C12.44 1.10999 14.43 3.09999 14.43 5.54999V8.87999Z"
            fill="#8E8E93"
        />
        <path
            d="M16.3431 8.29311C16.4988 8.13746 16.7099 8.05001 16.93 8.05001C17.1501 8.05001 17.3612 8.13746 17.5169 8.29311C17.6726 8.44877 17.76 8.65988 17.76 8.88001C17.76 12.88 14.71 16.18 10.82 16.6V18.04C10.82 18.2601 10.7326 18.4713 10.5769 18.6269C10.4212 18.7826 10.2101 18.87 9.99 18.87C9.76987 18.87 9.55876 18.7826 9.4031 18.6269C9.24745 18.4713 9.16 18.2601 9.16 18.04V16.6C5.26 16.19 2.22 12.88 2.22 8.88001C2.22 8.65856 2.30797 8.44617 2.46457 8.28958C2.62116 8.13299 2.83355 8.04501 3.055 8.04501C3.27646 8.04501 3.48884 8.13299 3.64544 8.28958C3.80203 8.44617 3.89 8.65856 3.89 8.88001C3.88 12.25 6.62 14.99 9.99 14.99C13.36 14.99 16.1 12.25 16.1 8.88001C16.1 8.65988 16.1874 8.44877 16.3431 8.29311Z"
            fill="#8E8E93"
        />
    </svg>
</template>
